import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Realmente puedo ganar $500+ sin experiencia?',
    answer: 'Sí. El 78% de nuestras estudiantes nunca habían vendido en línea. La guía es para principiantes completos con videos y scripts exactos.'
  }, {
    question: '¿Cuánto toma empezar a ganar?',
    answer: 'La mayoría hace su primera venta en 7-14 días. Algunas en 3-4 días. Con 1-2 horas diarias puedes ver resultados en tu primera semana.'
  }, {
    question: '¿Necesito invertir dinero?',
    answer: 'No. Trabajas con afiliados de TikTok Shop. Sin inventario, sin comprar productos. Solo tu celular y la guía.'
  }, {
    question: '¿Qué pasa si no me funciona?',
    answer: 'Tienes 30 días para probar. Si no estás satisfecha, te devolvemos cada peso. Sin preguntas. El riesgo es 100% mío.'
  }, {
    question: '¿La guía se actualiza?',
    answer: 'Sí. Acceso de por vida a todas las actualizaciones. Cuando TikTok Shop cambie, lo recibes gratis.'
  }, {
    question: '¿Cómo recibo la guía?',
    answer: 'Inmediatamente después de pagar recibes un correo con acceso. Puedes empezar en menos de 5 minutos.'
  }, {
    question: '¿Por qué es tan barato?',
    answer: 'Mi misión es ayudar al mayor número de mujeres. Otros cobran $3,000-$8,000. Yo prefiero vender más a precio justo.'
  }, {
    question: '¿Necesito mostrar mi cara?',
    answer: 'No necesariamente. La guía incluye estrategias con y sin mostrar tu cara. Tú eliges.'
  }];
  return <section className="section-spacing bg-gradient-warm" data-id="element-338">
      <div className="container-narrow" data-id="element-339">
        <div className="text-center mb-10" data-id="element-340">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black text-deep-cocoa mb-3" data-id="element-341">
            Preguntas frecuentes
          </h2>
          <p className="text-base text-deep-cocoa/70" data-id="element-342">
            Las dudas más comunes antes de empezar
          </p>
        </div>

        <div className="space-y-3" data-id="element-343">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-soft overflow-hidden hover:shadow-medium transition-shadow" data-id="element-344">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-5 py-4 flex items-center justify-between text-left hover:bg-almond-milk/30 transition-colors" data-id="element-345">
                <span className="font-bold text-deep-cocoa pr-3 text-sm sm:text-base" data-id="element-346">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-cta-primary flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-347" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`} data-id="element-348">
                <div className="px-5 pb-4 text-deep-cocoa/80 leading-relaxed text-sm" data-id="element-349">
                  {faq.answer}
                </div>
              </div>
            </div>)}
        </div>

        {/* CTA after FAQ */}
        <div className="mt-8 text-center" data-id="element-350">
          <div className="bg-white rounded-xl p-6 shadow-medium" data-id="element-351">
            <p className="text-base text-deep-cocoa mb-2" data-id="element-352">
              ¿Todavía tienes dudas?
            </p>
            <p className="text-deep-cocoa/70 text-sm mb-5" data-id="element-353">
              Recuerda: 30 días de garantía. Prueba sin riesgo.
            </p>
            <a href="https://buy.stripe.com/dRm28rgfodEa83g1X618c00" className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-gradient-to-r from-cta-primary to-cta-secondary text-white font-bold rounded-xl shadow-glow-orange hover:shadow-xl hover:scale-105 transition-all duration-300" data-id="element-354">
              Sí, Quiero Empezar Ahora
            </a>
          </div>
        </div>
      </div>
    </section>;
}